export interface StockAdjustmentReason {
  id: string;
  key: string;
  description: string;
}
